import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";

import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';

import TemplateLandingPageTecnologia from './pages/TemplateLandingPageTecnologia';

function App() {
  // Suprime o erro de ResizeObserver no desenvolvimento
  const resizeObserverError = window.onerror;
  window.onerror = (message, ...args) => {
    if (message?.includes('ResizeObserver')) return true;
    return resizeObserverError?.(...args);
  };


  return (
    <>
      <ConfigProvider locale={ptBR}>

        <ToastContainer />

        <Router>
          <main>
            <Routes>
              {/*TESTEANDO FUNCIONALIDADE DO MESMO COMPONENT PARA ESSAS DUAS PAGES */}
              <Route path="/" element={<TemplateLandingPageTecnologia />} />
              <Route path="/:url_section" element={<TemplateLandingPageTecnologia />} />
            </Routes>
          </main>
        </Router>

      </ConfigProvider>
    </>
  );
}

export default App;